import { render, staticRenderFns } from "./PageAll.vue?vue&type=template&id=348860b0&scoped=true&"
import script from "./PageAll.vue?vue&type=script&lang=js&"
export * from "./PageAll.vue?vue&type=script&lang=js&"
import style0 from "./PageAll.vue?vue&type=style&index=0&id=348860b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348860b0",
  null
  
)

export default component.exports